<template>
  <div>
    <div>
      <HeadingLv4
        text="ヒポクラへの同時登録"
        class="hpcr_heading"
        v-if="isRegisterByLine"
      />
      <HeadingLv4
        text="オンライン医局®「ヒポクラ」の同時登録【会員限定特典】"
        class="hpcr_heading"
        v-else
      />
    </div>

    <TextBlock class="textBlock">
      <p class="notes">
        医師の臨床力とモチベーションを高める日本最大級のオンライン医局®「ヒポクラ」は、株式会社エクスメディオと株式会社マイナビが共同運営する医師向けサービスです。
      </p>
      <p class="notes">
        先輩医師の診療やキャリアのQ&amp;A、PubMedの日本語検索などのお役立ち機能を、医学生も利用できるのはマイナビレジデント会員だけの特典です。将来にわたり役立つ場としてぜひご活用ください。
      </p>

      <p class="textRight">
        <TextLink link="/lp/hpcr" text="詳細はこちら" blank small />
      </p>
    </TextBlock>

    <div>
      <div v-if="!noIframe">
        <InlineFrame embedFrame>
          <iframe
            src="https://s3-ap-northeast-1.amazonaws.com/files.xmd.io/public/rule/use_policy.html"
            width="100%"
            frameborder="0"
          ></iframe>
        </InlineFrame>

        <InlineFrame embedFrame>
          <iframe
            src="https://s3-ap-northeast-1.amazonaws.com/files.xmd.io/public/rule/privacy_policy.html"
            width="100%"
            frameborder="0"
          ></iframe>
        </InlineFrame>

        <TextBlock class="textBlock">
          <p class="notes">
            上記の会員利用規約、プライバシーポリシーをご確認いただき、同意の上、登録手続きを進めてください。
          </p>
          <ul class="notes">
            <li>
              ＊ 個人情報の取り扱いについては<a
                href="/privacy_policy"
                target="_blank"
                >こちら</a
              >をご確認ください。
            </li>
          </ul>
        </TextBlock>
      </div>

      <div v-else>
        <TextBlock class="textFooter">
          <p class="textCenter">
            <button type="button" class="btn" @click="openTermsModal">
              利⽤規約
            </button>
            |
            <button type="button" class="btn" @click="openPolicyModal">
              プライバシーポリシー
            </button>
          </p>
        </TextBlock>
        <ModalHpcrTerms
          v-if="termsModal.isShow"
          :closeModal="closeTermsModal"
        />
        <ModalHpcrPolicy
          v-if="policyModal.isShow"
          :closeModal="closePolicyModal"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { reactive, defineComponent } from 'vue'
import HeadingLv4 from '@/components/elements/HeadingLv4.vue'
import InlineFrame from '@/components/block/InlineFrame.vue'
import TextBlock from '@/components/block/TextBlock.vue'
import TextLink from '@/components/elements/TextLink.vue'
import ModalHpcrTerms from '@/components/block/ModalHpcrTerms.vue'
import ModalHpcrPolicy from '@/components/block/ModalHpcrPolicy.vue'

export default defineComponent({
  name: 'HpcrRegister',

  components: {
    HeadingLv4,
    InlineFrame,
    TextBlock,
    TextLink,
    ModalHpcrTerms,
    ModalHpcrPolicy
  },
  props: {
    isRegisterByLine: {
      default: false
    },
    noIframe: {
      default: false
    }
  },
  setup() {
    const termsModal = reactive({
      isShow: false
    })
    const closeTermsModal = () => (termsModal.isShow = false)
    const openTermsModal = () => (termsModal.isShow = true)
    const policyModal = reactive({
      isShow: false
    })
    const closePolicyModal = () => (policyModal.isShow = false)
    const openPolicyModal = () => (policyModal.isShow = true)

    return {
      termsModal,
      closeTermsModal,
      openTermsModal,
      policyModal,
      closePolicyModal,
      openPolicyModal
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.hpcr_heading {
  margin-bottom: 20px;
}

.textBlock {
  margin-bottom: 28px;
}
.textFooter {
  margin-bottom: 14px;
}
.textRight {
  text-align: right;
}
.textCenter {
  text-align: center;
}
.btn {
  text-align: center;
  color: var.$color-main-text;
  font-size: 1.2rem;
  word-break: break-all;
  transition: 0.2s;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
}
</style>
